module.exports = __webpack_public_path__ + "static/media/icon-social-insta.ffb7a652.svg";